// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__JTghx","bgImage":"firstFold_bgImage__GHolp","heading":"firstFold_heading__MUm1e","subParagraph":"firstFold_subParagraph__b6vac"};